export default (row = {}, showChildSelect, shouldHideSelect) => {
  if (shouldHideSelect && shouldHideSelect({ row })) return true;
  if (row && !showChildSelect && row.expandTableIdentifier) return true;
  return false;
};
